<template>
  <v-sheet
    elevation="0"
    class="pa-2 my-2 sheet"
  >
    <v-row
      v-if="!contenuModifiable.isOpenForm && !isDelete"
      no-gutters
      class="d-flex px-2"
    >
      <v-col
        cols="1"
        class="align-self-center"
      >
        <v-icon class="cursor-hand handle v-icon--link">
          mdi-drag-vertical
        </v-icon>
      </v-col>
      <v-col
        cols="1"
        class="align-self-center"
      >
        <v-badge
          color="secondary"
          :content="contenu.ordre + 1"
        />
      </v-col>
      <v-col
        cols="8"
        class="align-self-center"
      >
        <div class="action texte-gris-fonce">
          {{ contenuCourt }}
        </div>
      </v-col>
      <v-col
        cols="2"
        class="d-flex align-self-center"
      >
        <v-btn
          color="black"
          text
          icon
          @click="onEdit"
        >
          <v-icon>mdi-pencil-outline</v-icon>
        </v-btn>
        <v-btn
          color="black"
          text
          icon
          @click="onDelete"
        >
          <v-icon>mdi-trash-can-outline</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <div
      v-else-if="isDelete"
      class="d-flex pa-2 align-center"
    >
      <div class="texte texte-gris-fonce mr-auto">
        Voulez-vous supprimer ce contenu ?
      </div>
      <AgrButton
        color="error"
        class="mr-2"
        @click.stop="confirmDelete"
      >
        <span class="text-white">Oui</span>
      </AgrButton>
      <AgrButton
        color="primary"
        outlined
        @click.stop="isDelete = false"
      >
        <span>Non</span>
      </AgrButton>
    </div>

    <div v-else>
      <v-textarea
        v-model="contenuModifiable.message"
        placeholder="Commencer la saisie synthétique..."
        clearable
        maxlength="250"
        outlined
        required
        auto-grow
        :rules="rules.required"
        clear-icon="mdi-close-circle"
        counter="250"
      />
      <v-row class="d-flex justify-space-around">
        <v-col>
          <AgrButton
            class="pa-5"
            outlined
            block
            @click="onClose"
          >
            Annuler
          </AgrButton>
        </v-col>
        <v-col>
          <AgrButton
            :disabled="!isValid"
            class="pa-5"
            block
            @click="onSave"
          >
            Valider
          </AgrButton>
        </v-col>
      </v-row>
    </div>
  </v-sheet>
</template>

<script>
import { AgrButton } from '@agrial/ui'
import { truncate, cloneDeep } from 'lodash'

export default {
  name: 'SaisieSynthese',
  components: { AgrButton },
  props: {
    contenu: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      contenuModifiable: {},
      isDelete: false,
      rules: {
        required: [v => !!v || 'Champ requis']
      }
    }
  },
  computed: {
    isValid () {
      return this.contenuModifiable.message && this.contenuModifiable.message.trim() !== ''
    },
    contenuCourt () {
      return truncate(this.contenu.message, { length: 50, omission: '...' })
    }
  },
  watch: {
    contenu: {
      handler (newVal) {
        this.contenuModifiable = cloneDeep({ message: '', ...newVal })
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    onEdit () { this.$emit('openForm', this.contenu.id) },
    onClose () { this.$emit('closeForm', this.contenu.id) },
    onSave () {
      if (this.isValid) {
        this.$emit('save', this.contenuModifiable)
      }
    },
    onDelete () { this.isDelete = true },
    confirmDelete () {
      this.$emit('delete', this.contenu.id)
      this.isDelete = false
    }
  }
}
</script>

<style lang="scss" scoped>
.cursor-hand {
  cursor: grab !important;
  user-select: none;
  &:active { cursor: grabbing !important; }
}
::v-deep .ghost .cursor-hand { cursor: grabbing !important; }
.sheet { border: 1px solid #f1f2f5; }
</style>